export default {
  namespaced: true,
  state: {
    userName: "",
    userData: {},
    visibleCheckUser: false,
    verifyType: "",
  },
  getters: {},
  mutations: {
    SET_USER_NAME(state, val) {
      state.userName = val;
    },
    SET_VERIFY_TYPE(state, val) {
      state.verifyType = val;
    },
    SET_VISIBLE_CHECK_USER(state, val) {
      state.visibleCheckUser = val;
    },
    SET_USER_DATA(state, val) {
      state.userData = val;
    },
  },
  actions: {
    setUserName({ commit }, val) {
      commit("SET_USER_NAME", val);
    },
    setVisibleCheckUser({ commit }, val) {
      commit("SET_VISIBLE_CHECK_USER", val);
    },
    setVerifyType({ commit }, val) {
      commit("SET_VERIFY_TYPE", val);
    },
    setUserData({ commit }, val) {
      commit("SET_USER_DATA", val);
    },
  },
};
